<template>
  <div
    class="organize-tree x-height-100"
    :style="{ width: leftWidth }"
    data-automation="organizeTree"
  >
    <div :class="['organize x-flex-y', { border: border }]">
      <div class="seach x-padding x-flex-align">
        <el-input
          class="seach-input"
          v-model="filterText"
          size="small"
          suffix-icon="el-icon-search"
          :placeholder="placeholder"
        ></el-input>
        <el-button
          v-if="showAdd"
          class="x-add-btn x-margin-l"
          type="primary"
          icon="iconfont iconIocn-enlarge"
          :disabled="active.organizationType === 1 ? false : true"
          size="small"
          @click="add"
          >{{ $t('HT.add') }}</el-button
        >
      </div>
      <div class="tree x-padding-x x-flex-one x-scrollbar-show">
        <el-tree
          ref="tree"
          :data="data"
          :props="defaultProps"
          :node-key="nodeKey"
          default-expand-all
          :current-node-key="active.id"
          :expand-on-click-node="false"
          :highlight-current="true"
          :filter-node-method="filterNode"
          @node-click="nodeClick"
        >
          <div class="x-flex-align x-overflow-hidden" slot-scope="{ node, data }">
            <span class="x-flex-one x-overflow-hidden" :title="data[defaultProps.label]">{{
              data[defaultProps.label]
            }}</span>
            <span
              v-if="showPlus && data.nodeType !== 3"
              class="x-margin-l iconfont iconIocn-enlarge"
              @click="addPlus(data)"
            ></span>
          </div>
        </el-tree>
      </div>
    </div>
    <div v-if="showCut" class="telescopic x-flex-center" @click="telescopic">
      <i class="mask"></i>
      <i
        :class="[
          'iconfont iconIocn-Flipover x-grey-text',
          { left: leftWidth === '0px' ? true : false }
        ]"
      ></i>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n/index.js';
export default {
  name: 'MyOrganizeTree',
  props: {
    width: {
      type: String,
      default: '300px'
    },

    showAdd: {
      // 是否有新增按钮
      type: Boolean,
      default: false
    },

    border: {
      // 是否有边框
      type: Boolean,
      default: true
    },

    showPlus: {
      // 是否有添加按钮
      type: Boolean,
      default: false
    },

    showCut: {
      // 是否有切换按钮
      type: Boolean,
      default: true
    },

    nodeKey: {
      // 作为唯一key的字段
      type: String,
      default: 'id'
    },

    placeholder: {
      // 输入框
      type: String,
      default: () => i18n.t('HT.organizeTree.placeholder')
    },

    data: {
      // 树形数据
      type: Array,
      default: () => {
        return [];
      }
    },

    defaultProps: {
      // 树形配置
      type: Object,
      default: () => {
        return {
          children: 'childOrgList',
          label: 'company'
        };
      }
    },

    active: {
      // 当前选中的数据
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      filterText: '',
      leftWidth: this.width
    };
  },

  methods: {
    /**
     * 搜索组织树
     * @param {String} value 输入的值
     * @param {Object} data 数据
     */
    filterNode(value, data) {
      if (!value) return true;
      let key = this.defaultProps.label;
      return data[key].indexOf(value) !== -1;
    },

    /**
     * 点击树节点
     * @param {Object} val 点击的当前节点数据
     * @param {Object} node 节点对应的node
     * @param {Object} el 节点组件本身
     */
    nodeClick(val, node, el) {
      this.$emit('nodeClick', val, node, el);
    },

    /**
     * 新增按钮方法
     */
    add() {
      this.$emit('add');
    },

    addPlus(data) {
      this.$emit('addPlus', data);
    },

    /**
     * 展开伸缩
     */
    telescopic() {
      this.leftWidth = this.leftWidth === this.width ? '0px' : this.width;
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },

    width(val) {
      this.leftWidth = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.organize-tree {
  position: relative;
  transition: all 0.3s ease-in;

  .border {
    border-right: 1px solid #d7dde780;
  }

  .organize {
    height: 100%;
    background-color: #fff;
    overflow: hidden;

    .seach-input {
      min-width: 120px;
      overflow: hidden;
    }

    .tree {
      box-sizing: border-box;
      padding-bottom: 20px;
      overflow-x: hidden;
    }
  }

  .telescopic {
    position: absolute;
    top: 50%;
    left: 100%;
    transform: translateY(-50%);
    cursor: pointer;

    .mask {
      width: 0;
      height: 26px;
      border-left: 12px solid #e8e8e8;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
    }

    .iconfont {
      position: absolute;
      left: -1px;
      font-size: 12px;
      transform: rotateY(180deg);
    }

    .left {
      transform: rotateY(360deg);
    }
  }
}
</style>

<style lang="scss">
// 激活高亮效果
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  color: #0087ff;
}
</style>
